import { Layers, UserKey } from 'lucide-react';
import { lazy } from 'react';

import { type UtilityDefinition, UtilityId } from './types';

/**
 * Single source of truth for every utility in the hub. The sidebar, the Home
 * dashboard, and the router all read from this list, filtered by
 * `usePermissions()` — a Utility only appears anywhere once it's added here
 * with a real `element`. The order here determines the order in the sidebar and other listings.
 */
export const utilityRegistry: UtilityDefinition[] = [
  {
    description: 'Push a batch of files into Autodesk Construction Cloud in one pass.',
    element: lazy(() => import('@features/acc-mass-upload/AccMassUploadApp')),
    icon: Layers,
    id: UtilityId.AccMassUpload,
    owner: 'Ops Data Apps',
    path: `/utilities/${UtilityId.AccMassUpload}`,
    title: 'ACC Mass Upload',
  },
  {
    description: 'Manage user accounts & group access within the Ops Utility Hub.',
    element: lazy(() => import('@features/manage-permissions/ManagePermissionsApp')),
    icon: UserKey,
    id: UtilityId.ManagePermissions,
    owner: 'Ops Data Apps',
    path: `/utilities/${UtilityId.ManagePermissions}`,
    title: 'Manage Permissions',
  },
];
